/// <amd-module name="Analytics/Management/AnalyticsStatusComponent" />
import * as Resources from "Analytics/Management/Resources";
import React = require("react");
import { FormatComponent } from "VSS/Platform/Components/Format/Format";
import { VssComponent } from "VSS/Platform/Layout";
import { Ago } from "VSSUI/Ago";
import { IStatusProps, Status, StatusSize } from "VSSUI/Status";
import { AgoFormat } from "VSSUI/Utilities/Date";

export interface IAnalyticsStatusProps {
    statusType: IStatusProps;
    statusText: string;
    statusExpandedText: string;
    pausedDate?: Date;
}

export class AnalyticsStatusComponent extends VssComponent<IAnalyticsStatusProps> {
    public render(): JSX.Element {
        return (
            <div className="flex-column flex-center flex-grow flex-wrap">
                <Status {...this.props.statusType} size={StatusSize.xl} text={this.props.statusText} className="analytics-management-status" />
                <p className="analytics-management-status-details">{this.props.statusExpandedText}</p>

                {this.props.pausedDate ? (
                    <FormatComponent className="analytics-management-paused-since" format={Resources.AnalyticsPausedSince}>
                        <Ago date={this.props.pausedDate} format={AgoFormat.Extended} />
                    </FormatComponent>
                ) : null}
            </div>
        );
    }
}
